export default __webpack_public_path__ + "static/media/upload_icon.f957150a.svg";